import React, { Component } from 'react';
import PropTypes from "prop-types";
import {Form, Control, Errors} from 'react-redux-form';
import {allLower, allUpper/*, firstCapital*/} from "../parsers";
import {isCurp, isEmail, email, isRequired, isRfc, maxLength, phoneNumber} from "../field_validations";
import DatePick from "../forms/datepicker";
import _ from 'lodash';
import Loading from './../../elements/loading';
import GreetingsSelect from "../forms/greeting_select";

const propTypes = {
	profiles: PropTypes.object.isRequired,
	permissions: PropTypes.array.isRequired,
	loadFormData: PropTypes.func.isRequired,
	projectEmployeeSave: PropTypes.func.isRequired
}

class ProfilesEditForm extends Component{
	render(){
		const {profiles, permissions, match} = this.props;
		let profileRev = profiles.revision ? profiles.revision.body : undefined;
		let pc = _.find(permissions, (o) => {return o==='Create'});
		let employeesAgency = !_.isEmpty(profiles.data.agency) ? profiles.data.agency.employees:[];
		let employeesProject = !_.isEmpty(profiles.data.employees) ? profiles.data.employees:[];
		return (
			<div className="columns">
				<div className="column">
					{profileRev && !_.isEmpty(profileRev.comment) && !profiles.isFetching ?
						<div className={`message is-${profileRev.status}`}>
							<div className="message-header">Comentarios</div>
							<div className="message-body">
								<p>{profileRev.comment}</p>
							</div>
						</div>
						: ''}
					<Form model="project.profiles.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="role_id" className="label">Perfiles <span className="small has-text-danger">*</span></label>
								<div className={`select${profiles.isFetching ? ' is-loading' : ''}${profileRev ? ' is-'+profileRev.status : ''}`}>
									<select ref="roleSelect" id="role_id" onChange={() => this._handleChangeRole()}>
										<option value={0} defaultValue>-- Perfiles --</option>
										{_.map(profiles.data.roles, (option, key) => {
											let registred = _.find(employeesAgency,{role_id: option.id});
											if(option.agenciable_type === 'cdm' && match.params.modality === 'modalidad-iii'){
												registred = _.find(employeesProject,{role_id: option.id, project_goal_agency:{agency_id:option.agency_id}});
											}
											//return <option key={key} value={option.id} data-agency={option.agency_id} className={option.registrable === 0 ? 'has-text-danger':''}>{`${option.display}${(option.agency.agenciable && option.agency.agenciable.name ? ` ${option.agency.agenciable.name}`:'')}`}</option>;
											return <option key={key} value={option.id} data-type={option.agenciable_type} data-agency={option.agency_id} className={registred === undefined ? 'has-text-danger':''}>{`${option.display}${match.params.modality === 'modalidad-iii' && option.agenciable_type === 'cdm' && option.agency.agenciable.name ? ` - ${option.agency.agenciable.name}`:''}`}</option>;
										})}
									</select>
								</div>
								<Errors model=".roles.role" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debe seleccionar un perfil' }} />
							</div>

							<div className="control">
								<p style={{marginBottom:'.5em'}}>&nbsp;</p>
								<div className="tags has-addons">
									<span className="tag is-medium">Perfiles cargados</span>
									<span className="tag is-medium is-primary">{_.size(employeesAgency) + _.size(employeesProject)}</span>
								</div>
							</div>

							<div className="control">
								<p style={{marginBottom:'.5em'}}>&nbsp;</p>
								<div className="tags has-addons">
									<span className="tag is-medium">Perfiles pendientes</span>
									<span className="tag is-medium is-danger">{(_.size(profiles.data.roles) - (_.size(employeesAgency) + _.size(employeesProject)))}</span>
								</div>
							</div>
						</div>

						{profiles.edit.isFetching ? <Loading message="Cargando perfil..." />:
							[<h5 className="is-5 title" key="profiles-title" style={{marginTop: '30px'}}>Datos generales</h5>,
								<div className="hero is-light" key="profiles-info">
									<div className="hero-body">
										<div className="field is-grouped">
											<div className="control">
												<label htmlFor="title" className="label">Saludo <span className="small has-text-danger">*</span></label>
												<div className={`select${profiles.isFetching ? ' is-loading' : ''}${profileRev ? ' is-'+profileRev.status : ''}`}>
													<Control model=".title" id="title" component={GreetingsSelect} value={profiles.edit && profiles.edit.title ? profiles.edit.title:''} validateOn="change" errors={{isRequired}} disabled={this._blockField()} />
												</div>
												<Errors model=".title" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Debes elegir un saludo'}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
												<Control.text model=".name" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} id="name" errors={{isRequired}} validateOn="change" disabled={this._blockField()} />
												<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="last_name" className="label">Primer apellido <span className="small has-text-danger">*</span></label>
												<Control.text model=".last_name" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} id="last_name" errors={{isRequired}} validateOn="change" disabled={this._blockField()}/>
												<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="slast_name" className="label">Segundo apellido</label>
												<Control.text model=".slast_name" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} id="slast_name" disabled={this._blockField()}/>
											</div>
										</div>

										<div className="field is-grouped">
											<div className="control is-expanded">
												<label htmlFor="scholarship" className="label">Escolaridad <span className="small has-text-danger">*</span></label>
												<Control.text model=".scholarship" id="scholarship" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="Escolaridad" errors={{isRequired}} disabled={this._blockField()}/>
												<Errors model=".scholarship" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El Nombramiento es obligatoria'}} />
											</div>
										</div>

										<div className="field is-grouped">
											<div className="control is-expanded">
												<label htmlFor="period_start" className="label">Fecha en que asumió cargo <span className="small has-text-danger">*</span></label>
												<Control.text model=".period_start" id="period_start" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} errors={{isRequired}} component={DatePick} disabled={this._blockField()}/>
												<Errors model=".period_start" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha en la que asumió el cargo es obligatoria. '}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="period_end" className="label">Fin de gestion </label>
												<Control.text model=".period_end" id="period_end" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} component={DatePick} disabled={this._blockField()}/>
											</div>
										</div>

										<div className="field is-grouped">
											<div className="control">
												<label htmlFor="sex" className="label">Sexo <span className="small has-text-danger">*</span></label>
												<div className={`select${profiles.isFetching ? ' is-loading' : ''}${profileRev ? ' is-'+profileRev.status : ''}`}>
													<Control.select model=".sex" id="sex" value={profiles.edit && profiles.edit.sex ? profiles.edit.sex:''} errors={{isRequired}} validateOn="change" disabled={this._blockField()}>
														<option value="">--- Sexo ---</option>
														<option value="M">Mujer</option>
														<option value="H">Hombre</option>
													</Control.select>
												</div>
												<Errors model=".sex" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El sexo es obligatorio'}} />
											</div>
											<div className="control is-expanded">
												<label htmlFor="rfc" className="label">RFC <span className="small has-text-danger">*</span></label>
												<Control.text model=".rfc" id="rfc" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="RFC" errors={{isRequired, isRfc}} validateOn="change" parser={ allUpper } disabled={this._blockField()}/>
												<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El RFC es obligatorio. ', isRfc: 'RFC inválido. '}} />
											</div>
											<div className="control is-expanded">
												<label htmlFor="curp" className="label">CURP <span className="small has-text-danger">*</span></label>
												<Control.text model=".curp" id="curp" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="CURP" errors={{isRequired, maxLength: maxLength(18), isCurp}} validateOn="change" parser={ allUpper } disabled={this._blockField()}/>
												<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La CURP es obligatoria. ', maxLength: 'CURP inválida. '}} />
											</div>
										</div>

										<div className="field is-grouped">
											<div className="control is-expanded">
												<label htmlFor="email" className="label">Email principal<span className="small has-text-danger">*</span></label>
												<Control.text model=".email" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="Email principal *" errors={{isRequired, isEmail}} validateOn="change" parser={ allLower } disabled={this._blockField()}/>
												<Errors model=".email" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El email es obligatorio'}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="email_2" className="label">Email secundario </label>
												<Control.text model=".email_2" id="email_2" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="Email secundario" errors={{email}} validateOn="change" parser={ allLower } disabled={this._blockField()}/>
												<Errors model=".email_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{email}} />
											</div>
										</div>

										<div className="field is-grouped">
											<div className="control is-expanded">
												<label htmlFor="telephone" className="label">Teléfono principal <span className="small has-text-danger">*</span></label>
												<Control.text model=".telephone" value={profiles.edit && profiles.edit.telephone ? profiles.edit.telephone:''} id="telephone" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} placeholder="Teléfono principal" maxLength={10} errors={{isRequired, phoneNumber}} validateOn="change" disabled={this._blockField()}/>
												<Errors model=".telephone" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El Teléfono es obligatorio'}} />
											</div>

											<div className="control is-expanded">
												<label htmlFor="telephone_2" className="label">Teléfono alterno</label>
												<Control.text model=".telephone_2" id="telephone_2" className={`input${profileRev ? ' is-'+profileRev.status : ''}`} maxLength={10} placeholder="Teléfono alterno" errors={{phoneNumber}} validateOn="change" disabled={this._blockField()}/>
												<Errors model=".telephone_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{phoneNumber}} />
											</div>
										</div>
									</div>
								</div>]}

						<div className="field is-grouped is-grouped-right" style={{marginTop: '30px'}}>
							<div className="control">
								<button type="button" model="project" className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
							</div>

							{pc ?
							<div className="control">
								<Control.button model="project.profiles" className="button is-large is-primary" disabled={this._blockField()}>Guardar</Control.button>
							</div>:''}
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values){
		let selector = this.refs['roleSelect'];
		let valuesPackage = {
			...values,
			role_id: _.toNumber(selector.value)
		}
		this.__sendSaveRequest(valuesPackage);
	}

	__sendSaveRequest(values) {
		const { modality, state, municipality } = this.props.match.params;
		this.props.projectEmployeeSave(modality, state, municipality, values);
	}

	_handleChangeRole() {
		let selector = this.refs['roleSelect'];
		if(selector.value){
			this._loadEmployee(selector.value,selector[selector.selectedIndex].dataset.type,selector[selector.selectedIndex].dataset.agency);
		}
	}

	_loadEmployee(roleId, type, agency){
		const { profiles, match } = this.props;
		let employee = {};

		if(match.params.modality === 'modalidad-iii' && type === 'cdm'){
			employee = _.find(profiles.data.employees, {role_id: _.toNumber(roleId), project_goal_agency:{agency_id:_.toNumber(agency)}, status_id: 1})
		}else {
			employee = _.find(profiles.data.agency.employees, {role_id: _.toNumber(roleId), status_id: 1})
		}

		let response = {agency_id: _.toNumber(agency)}
		if(employee){
			_.mapKeys(employee,(item, key) => {
				response = {
					...response,
					[key]:item ? item:undefined
				}
			})
		}else {
			response = {
				...response,
				title: undefined, name: undefined, last_name: undefined, slast_name: undefined, sex: undefined, curp: undefined, rfc: undefined, scholarship: undefined,
				email: undefined, email_2: undefined, telephone: undefined, telephone_2: undefined, period_start: undefined, period_end: undefined
			}
		}

		this.props.loadFormData('project.profiles.edit', {...response});
	}

	_blockField() {
		let { profiles } = this.props;
		let response = false;
		let editable = profiles.editable;
		let profilesRevision = !_.isEmpty(profiles.revision) ? profiles.revision.body : undefined;
		if(!_.isEmpty(profilesRevision) && !profiles.isFetching){
			let allow = profilesRevision.allow_edit === 'true' ? true : false;
			if(editable && allow){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !profiles.isFetching){
			response = false;
		}else {
			response = true;
		}

		return response;
	}
}

ProfilesEditForm.propTypes = propTypes;

export default ProfilesEditForm;



// WEBPACK FOOTER //
// ./src/elements/project/profiles.jsx